import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['tab', 'tabView', 'scrollable']
  static values = {tab: String}

  initialize() {
    // find tab target with tabActive true
    const firstTab = this.tabViewTargets.find((elem, index) => {
      return elem.dataset.tabActive === 'true'
    })
    if (firstTab) {
        this.displayTab(firstTab.dataset.tabName)
    }
  }

  switch(event) {
    var name = ''
    if (event.target.tagName == 'SELECT') {
      name = event.target.value
    } else {
      name = event.target.dataset.tabName
    }
    this.displayTab(name)
  }

  displayTab(tabName) {
    this.tabTargets.forEach((elem, index) => {
      elem.classList.remove('bg-indigo-100', 'font-semibold')
      if (elem.dataset.tabName === tabName) {
        elem.classList.add('bg-indigo-100', 'font-semibold')
      }
    })
    this.tabViewTargets.forEach((elem, index) => {
      elem.classList.add('hidden')
      if (elem.dataset.tabName === tabName) {
        elem.classList.remove('hidden')
      }
    })
  }

  scrollLeft() {
    if (this.hasScrollableTarget) {
      this.scrollableTarget.scrollBy({ left: -100, behavior: 'smooth' })
    }
  }

  scrollRight() {
    if (this.hasScrollableTarget) {
      this.scrollableTarget.scrollBy({ left: 100, behavior: 'smooth' })
    }
  }

  // New switch method for styled tabs
  switchStyled(event) {
    const name = event.currentTarget.dataset.tabName;
    this.displayStyledTab(name);
  }

  // New display method for styled tabs
  displayStyledTab(tabName) {
    this.tabTargets.forEach((elem, index) => {
      // Remove all potential active/inactive classes
      elem.classList.remove('bg-indigo-200', 'text-indigo-600', 'text-gray-600', 'hover:bg-indigo-100', 'bg-indigo-100', 'font-semibold')
      if (elem.dataset.tabName === tabName) {
        // Add active classes
        elem.classList.add('bg-indigo-200', 'text-indigo-600')
      } else {
        // Add inactive classes
        elem.classList.add('text-gray-600', 'hover:bg-indigo-100')
      }
    })
    this.tabViewTargets.forEach((elem, index) => {
      elem.classList.add('hidden')
      if (elem.dataset.tabName === tabName) {
        elem.classList.remove('hidden')
      }
    })
  }
}
